import React from 'react'
import PsiokosocialNav from '../../components/psikosocialnav'

const Analiza1: React.FC = () => {
  return (
    <>
      <PsiokosocialNav />
      <h3 className="mt-16">Duke u punuar .....</h3>
    </>
  )
}

export default Analiza1
